import { render, staticRenderFns } from "./DocumentDownload.vue?vue&type=template&id=7ffe061c&scoped=true&"
import script from "./DocumentDownload.vue?vue&type=script&lang=js&"
export * from "./DocumentDownload.vue?vue&type=script&lang=js&"
import style0 from "./DocumentDownload.vue?vue&type=style&index=0&id=7ffe061c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffe061c",
  null
  
)

export default component.exports